import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output, TemplateRef,
  Type,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { NgIf, NgStyle } from "@angular/common";
import { LoadingService } from "../../services/loading.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { SkeletonLoaderComponent } from "../skeleton-loader/skeleton-loader.component";
import { SpinnerLoaderComponent } from "../spinner-loader/spinner-loader.component";

@Component({
  selector: 'app-right-panel',
  standalone: true,
  imports: [
    SvgIconComponent,
    NgIf,
    SkeletonLoaderComponent,
    SpinnerLoaderComponent,
    NgStyle
  ],
  templateUrl: './right-panel.component.html',
  styleUrl: './right-panel.component.scss',
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      state('out', style({
        transform: 'translateX(100%)',
        opacity: 0
      })),
      transition('in => out', [
        animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ]),
      transition('out => in', [
        animate('400ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ])
    ])
  ]
})
export class RightPanelComponent {
  isLoading: boolean = false;

  @Input() title: string | undefined;
  @Input() showActionBtns = false;
  @Input() primaryActionBtnText = 'Save';
  @Input() secondaryActionBtnText = 'Cancel';
  @Input() panelWidth!: string;

  @Output() close = new EventEmitter<void>();
  @Output() refreshParent = new EventEmitter<void>();
  @Output() primaryActionBtnEmitter = new EventEmitter<any>();
  @Input() hidePrimaryButton?: boolean = false;

  @ViewChild('rightPanelContent', { read: ViewContainerRef, static: true })
  rightPanelContent!: ViewContainerRef;

  panelState: 'in' | 'out' = 'out';

  constructor(private loadingService: LoadingService,
              private cdr: ChangeDetectorRef) {
    this.loadingService = loadingService;
  }

  ngOnInit() {
    this.loadingService.loading$.subscribe({
      next: (data) => {
        this.isLoading = data.isLoading
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.isLoading = false
        console.error('Error loading service:', err);
      }
    })
  }

  ngAfterViewInit() {
    requestAnimationFrame(() => {
        this.panelState = 'in';
    });
  }

  onClose(params?: any) {
    this.panelState = 'out';
    setTimeout(() => {
      this.close.emit(params);
    }, 400);
  }

  loadComponent(componentOrTemplate: Type<any> | TemplateRef<any>, data?: Partial<any>): any {
    this.rightPanelContent.clear();

    if (componentOrTemplate instanceof TemplateRef) {
      return this.rightPanelContent.createEmbeddedView(componentOrTemplate, { $implicit: data });
    } else {
      const componentRef = this.rightPanelContent.createComponent(componentOrTemplate);

      if (componentRef.instance) {
        (componentRef.instance as any).closeRightPanel = this.onClose.bind(this);

        if (data) {
          Object.assign(componentRef.instance, data);
        }
      }

      return componentRef;
    }
  }

  handlePrimaryBtnClick() {
    this.primaryActionBtnEmitter.emit()
  }
}
